import Blue from "~/core";
import Swiper, {
  Navigation,
	A11y
} from 'swiper';

Swiper.use([Navigation, A11y]);


new Blue({
	name: 'Contact Slider',
	selector: ".contact-list",
	setup(container) {
    const contacts = [...container.querySelectorAll(".contact__item")];
		if (contacts.length > 3) {
			container.classList.add("contact-list--carousel");
			const boundary = container.querySelector(".contact-list__boundary");
			const wrapper = container.querySelector(".contact-list__inner");
			const prev = document.createElement("button");
			const next = document.createElement("button");
			let idVal = "contact-carousel-" + Math.ceil((Math.random() + 1) * 5000).toString() + "-" + Math.ceil((Math.random() + 1) * 5000).toString();
			container.setAttribute("id", idVal);
			prev.classList.add("contact-list__prev");
			next.classList.add("contact-list__next");
			prev.setAttribute("aria-label", "Show previous group of contacts in the carousel");
			next.setAttribute("aria-label", "Show next group of contacts in the carousel");
			prev.setAttribute("aria-controls", idVal);
			next.setAttribute("aria-controls", idVal);
			container.insertAdjacentElement("afterbegin", prev);
			container.insertAdjacentElement("beforeend", next);
			const gap = 40;
			const contactsPerView = 3;
			const remainderViewItems = contacts.length % contactsPerView;
			const totalViews = Math.ceil(contacts.length / contactsPerView);
			let moduloHit = false;
			let currentViewIndex = 0;
			let topContactIndex = 0;
			let wrapperTopValue = 0;

			const setTopContactIndex = () => topContactIndex = moduloHit ? (currentViewIndex - 1) * contactsPerView + remainderViewItems : currentViewIndex * contactsPerView;
			const updateContactAttrs = activeContactArr => {
				contacts.forEach(c => {
					c.setAttribute("data-active", "false");
					c.setAttribute("aria-hidden", "true");
					c.style.visibility = "hidden";
				});
				activeContactArr.forEach(c => {
					c.setAttribute("data-active", "true");
					c.setAttribute("aria-hidden", "false");
					c.style.visibility = "visible";
				});
			}

			const adjustBoundaryHeight = () => {
				let activeContactsHeight = contacts[topContactIndex].offsetHeight + contacts[topContactIndex + 1].offsetHeight + contacts[topContactIndex + 2].offsetHeight;
				updateContactAttrs([contacts[topContactIndex], contacts[topContactIndex + 1], contacts[topContactIndex + 2]]);
				let totalHeight = activeContactsHeight + (2 * gap);
				let start = boundary.offsetHeight;
				boundary.style.height = totalHeight + "px";
				boundary.animate([
					{height: `${start}px`},
					{height: `${totalHeight}px`}
				], {
					duration: 350,
					easing: 'ease'
				});
			}

			const moveSlides = (indexDir) => {
				currentViewIndex += indexDir;

				if (currentViewIndex < 0 || currentViewIndex >= totalViews) return;

				if (currentViewIndex == 0) {
					moduloHit = false;
					prev.setAttribute("disabled", "true");
					next.removeAttribute("disabled");
				} else if (currentViewIndex == totalViews - 1) {
					moduloHit = remainderViewItems > 0;
					next.setAttribute("disabled", "true");
					prev.removeAttribute("disabled");
				} else {
					prev.removeAttribute("disabled");
					next.removeAttribute("disabled");
				}
				setTopContactIndex();
				let topContactTopVal = contacts[topContactIndex].getBoundingClientRect().top;
				let containerTopVal = container.getBoundingClientRect().top;
				let topDiff = containerTopVal - topContactTopVal;
				wrapperTopValue += topDiff;
				let start = wrapper.offsetTop;
				wrapper.style.top = wrapperTopValue + "px";
				wrapper.animate([
					{top: `${start}px`},
					{top: `${wrapperTopValue}px`}
				], {
					duration: 350,
					easing: 'ease'
				});
				adjustBoundaryHeight();
			}

			moveSlides(0); // initialize by "moving" in a direction diff of 0

			this.$addEvents(prev, "click.prevent", () => moveSlides(-1));
			this.$addEvents(next, "click.prevent", () => moveSlides(1));


			// ###########################################################
			// BELOW CODE IS FORMER SWIPER CODE WHICH WAS REPLACED W/ 
			// CUSTOM CODE SINCE SWIPER HAS SOME UNRESOLVED ISSUES W/
			// VERTICAL CAROUSELS
			// ###########################################################

			// container.classList.add("swiper");
			// const wrapper = container.querySelector(".contact-list__inner");
			// wrapper.classList.add("swiper-wrapper");
			// const prev = document.createElement("button");
			// const next = document.createElement("button");
			// prev.classList.add("swiper-button-prev");
			// next.classList.add("swiper-button-next");
			// container.insertAdjacentElement("beforeend", prev);
			// container.insertAdjacentElement("beforeend", next);
			// contacts.forEach(c => c.classList.add("swiper-slide"));
			// let gap = 32;

			// let heightsArray = contacts.map((c, i) => {
			// 	if (i <= contacts.length - 3) {
			// 		return c.offsetHeight + contacts[i + 1].offsetHeight + contacts[i + 2].offsetHeight;
			// 	} else return 0;
			// });

			// let largestHeightTotal = Math.max(...heightsArray);

			// let neededHeight = largestHeightTotal + 2 * gap;

			// container.style.height = neededHeight + "px";

			// const contactSwiper = new Swiper(container, {
			// 	speed: 600,
			// 	autoplay: false,
			// 	direction: "vertical",
			// 	slidesPerGroup: 1,
			// 	slidesPerView: 3,
			// 	spaceBetween: gap,
			// 	height: neededHeight,
			// 	modules: [
			// 		Navigation,
			// 		A11y,
			// 	],
			// 	navigation: {
			// 		nextEl: next,
			// 		prevEl: prev
			// 	},
			// 	on: {
			// 		afterInit: (swiper) => {
			// 			contacts.forEach((c, i) => {
			// 				if (i <= contacts.length - 3) {
			// 					let inners = [c.querySelector(".contact-item__inner"), contacts[i + 1].querySelector(".contact-item__inner"), contacts[i + 2].querySelector(".contact-item__inner")];
			// 					let totalHeight = inners.reduce((acc, inner) => acc + inner.offsetHeight, 0);
			// 					if (totalHeight == largestHeightTotal) {
			// 						setTimeout(() => {
			// 						c.style.height = "auto";
			// 						contacts[i + 1].style.height = "auto";
			// 						contacts[i + 2].style.height = "auto";
			// 					}, 500)
			// 					}
			// 				}
			// 			});
			// 		},
			// 	},
			// });
		}
	}
});